import React from 'react';
import MockupShell from './MockupShell';

const CATEGORIES = [
  {
    name: 'Referral Links',
    links: [
      { label: 'My BBC Quick List waitlist link', url: 'bbcquicklist.com/waitlist/BLDR4827', clicks: 142, signups: 12 },
      { label: 'Founders pre-launch link',          url: 'bbcquicklist.com/founders/BLDR4827', clicks: 38,  signups: 2 },
    ],
  },
  {
    name: 'Lead Capture Links',
    links: [
      { label: 'Crypto Beginners landing',  url: 'bbcquicklist.com/lead/crypto-101',  clicks: 84, signups: 7 },
      { label: 'List Builder Webinar opt-in', url: 'bbcquicklist.com/lead/webinar',     clicks: 23, signups: 4 },
    ],
  },
  {
    name: 'Rotators',
    links: [
      { label: 'Main A/B split rotator', url: 'bbcquicklist.com/r/main-split', clicks: 211, signups: 18 },
    ],
  },
  {
    name: 'Link-in-Bio',
    links: [
      { label: 'Instagram bio hub', url: 'bbcquicklist.com/bio/builder4827',   clicks: 67,  signups: 5 },
    ],
  },
  {
    name: 'Social Profiles',
    links: [
      { label: 'My Telegram channel',   url: 't.me/builder4827', clicks: '—', signups: '—' },
      { label: 'My X profile',           url: 'x.com/builder4827', clicks: '—', signups: '—' },
    ],
  },
  {
    name: 'Campaign Links',
    links: [
      { label: 'Q1 Builder Recruitment',  url: 'bbcquicklist.com/c/q1-builders', clicks: 19, signups: 1 },
    ],
  },
];

export default function LinkFile() {
  return (
    <MockupShell
      title="Link File"
      subtitle="One organized place for every link you share — referral, lead capture, rotator, bio, social, campaigns."
      dataTestId="mockup-link-file"
    >
      <div className="mk-grid mk-grid--3" style={{ marginBottom: 18 }}>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Total links</span><span className="mk-stat-value">14</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Clicks (30d)</span><span className="mk-stat-value">584</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Sign-ups attributed</span><span className="mk-stat-value">49</span></div></div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <button className="mk-btn" data-testid="link-file-add-btn">+ Add link</button>
        <button className="mk-btn mk-btn--ghost">+ New category</button>
        <button className="mk-btn mk-btn--ghost">Export CSV</button>
      </div>

      {CATEGORIES.map((cat, i) => (
        <div key={cat.name} className="mk-card" style={{ marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h3 style={{ margin: 0 }}>{cat.name}</h3>
            <span className="mk-badge mk-badge--gold">{cat.links.length} link{cat.links.length === 1 ? '' : 's'}</span>
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {cat.links.map((l, j) => (
              <li
                key={l.url}
                data-testid={`link-row-${i}-${j}`}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto auto',
                  gap: 12,
                  alignItems: 'center',
                  padding: '10px 0',
                  borderTop: j > 0 ? '1px solid var(--mk-border)' : 'none',
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{l.label}</div>
                  <div style={{ fontSize: 11, color: 'var(--mk-gold)', overflowX: 'auto', whiteSpace: 'nowrap' }}>{l.url}</div>
                </div>
                <div style={{ fontSize: 11, color: 'var(--mk-muted)', textAlign: 'right' }}>
                  {l.clicks} clicks<br />
                  {l.signups} sign-ups
                </div>
                <button className="mk-btn mk-btn--gold-outline" data-testid={`link-copy-btn-${i}-${j}`}>Copy</button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </MockupShell>
  );
}
